import React, { useState, useContext, useEffect, useCallback, useMemo, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import {
  Table,
  Form,
  Button,
  Pagination,
  Row,
  Col,
  Card,
  Badge,
  InputGroup,
  Modal,
  ListGroup,
} from "react-bootstrap";
import { utils, writeFile } from "xlsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GridPadrao.css";
import TestEmailModal from "../Configuracoes/EmailNotificacao/TestEmailModal";
import { Adicionar } from "../Generals/buttons";
import {
  FaSort,
  FaSortUp,
  FaSortDown,
  FaSearch,
  FaFilter,
  FaCog,
  FaFileExcel,
  FaPaperPlane,
  FaTimes,
  FaTrash,
  FaSave,
  FaDownload,
  FaFilePdf,
  FaColumns,
  FaGripVertical,
} from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { GlobalContext } from "../../Utils/GlobalContext";
import { mascararValor } from "../../Utils/lgpdMascara";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";
import calcDiasParaVcto from "../../Utils/calcDiasParaVcto";
import {
  applyDateFilter,
  getFilterableValue,
  applyNumericFilter,
} from "../../Utils/filtrosGrid";

const OPCOES_PADRAO = [10, 20, 30, 40, 50];

const BADGE_COLUNAS = {
  C: { label: "Customizado", bg: "#e0edff", color: "#1d4ed8" },
  P: { label: "Padrão",      bg: "#f0fdf4", color: "#15803d" },
};

/** Ordena colunas do modal: primeiro visível (S), depois por ordem numérica. */
const sortColunasPorVisivelEOrdem = (a, b) => {
  const visivelOrder = (v) => (v === "S" ? 0 : 1);
  const cmp = visivelOrder(a.visivel) - visivelOrder(b.visivel);
  if (cmp !== 0) return cmp;
  return (a.ordem || 0) - (b.ordem || 0);
};

const normalizarLabelColuna = (nomeColuna, labelFallback) => {
  const nome = String(nomeColuna || "").toLowerCase();
  if (nome === "dias_para_vencimento" || nome === "dias_vcto") return "Vence em";
  return labelFallback;
};

function GridPadrao({
  columns,
  data,
  onEdit,
  onInactivate,
  onAdd,
  addDisabled = false,
  addDisabledTitle,
  addDataTour,
  firstRowDataTour,
  acaoDataTour,
  configCamposDataTour,
  onTest,
  onPrintPdf,
  onConfigCampos,
  onAcao,
  acaoTitulo = "Ação",
  AcaoIcone,
  acaoVariant = "outline-info",
  onAcao2,
  acao2Titulo = "Ação",
  Acao2Icone,
  acao2Variant = "outline-info",
  defaultSortColumn,
  defaultSortOrder = "asc",
  rota,
  /** Se true, usa ObterVisaoColunas/SalvarVisaoColunas e exibe botão Colunas. Use false em GruposUsuario. */
  habilitaVisaoColunas = true,
  defaultFilters = {},
  disableInactivateWhen,
  disableInactivateTooltip,
  /** Opções do filtro de situação (ex.: Documentos usa Vigente/Vencido/Arquivado) */
  situacaoFilterOptions,
  /** Botões/elementos extras renderizados à direita do botão Colunas */
  acoesBotoes,
  /** Chaves do objeto de dados a excluir da exportação Excel */
  exportExcludeColumns = [],
  /**
   * Item #36 (LGPD): mapa "chave da coluna -> tipo lógico" (ver utils/lgpdMascara.js:
   * cpf, cnpj, email, telefone, data_nascimento, endereco, observacoes,
   * valor_monetario, nome_completo). Quando a entidade ativa tem
   * lgpd_ocultar_dados = 'S', o valor exportado é substituído pela versão
   * mascarada em vez de a coluna ser omitida — ao contrário de
   * exportExcludeColumns, a coluna continua existindo no arquivo.
   */
  exportMaskColumns = {},
  /** Paginação/ordenação/filtros no servidor — data já vem paginada */
  serverSide = false,
  totalItems = 0,
  loading = false,
  onServerParamsChange,
}) {
  const { globalData, darkMode } = useContext(GlobalContext);
  const mostrarColunaId = globalData?.mostrarColunaId !== false;
  const { toast } = useFeedback();
  const numeroLinhasConfig = Number(globalData?.numero_linhas_grid) || 10;
  const userId = globalData?.user_id || localStorage.getItem("user_id");
  const entidadeId = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const token = localStorage.getItem("authToken");

  const defaultF = defaultFilters.filters ?? { situacao: "a" };
  const defaultDF = defaultFilters.dateFilters ?? {};

  const [sortColumn, setSortColumn] = useState(defaultSortColumn || "");
  const [sortOrder, setSortOrder] = useState(defaultSortOrder);
  const [filters, setFilters] = useState(defaultF);
  const [numericFilters, setNumericFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(numeroLinhasConfig);

  useEffect(() => {
    setItemsPerPage(numeroLinhasConfig);
    setCurrentPage(1);
  }, [numeroLinhasConfig]);
  const [showTestModal, setShowTestModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dateFilters, setDateFilters] = useState(defaultDF);
  const [showFilters, setShowFilters] = useState(false);
  const [filterModalColumn, setFilterModalColumn] = useState(null);
  const [filterModalSelections, setFilterModalSelections] = useState({});
  const [savingFilter, setSavingFilter] = useState(false);
  const [loadingCarregar, setLoadingCarregar] = useState(false);
  const [diasParaVencimento, setDiasParaVencimento] = useState("");

  const [visaoColunas, setVisaoColunas] = useState([]);
  const [showColunasModal, setShowColunasModal] = useState(false);
  const [colunasModalList, setColunasModalList] = useState([]);
  const [savingColunas, setSavingColunas] = useState(false);
  const [dragColIdx, setDragColIdx] = useState(null);
  const [overColIdx, setOverColIdx] = useState(null);
  const dragColNode = useRef(null);
  const lastServerParamsRef = useRef(null);
  const onServerParamsChangeRef = useRef(onServerParamsChange);
  onServerParamsChangeRef.current = onServerParamsChange;

  const temColunaAcoes = Boolean(
    onInactivate || onTest || onPrintPdf || onConfigCampos || onAcao || onAcao2
  );

  useEffect(() => {
    lastServerParamsRef.current = null;
  }, [entidadeId, rota]);

  const colBg         = "var(--surface-card)";
  const colBgHead     = "var(--surface-sunken)";
  const colBorda      = "var(--border-default)";
  const colTexto      = "var(--text-body)";
  const colTextoMuted = "var(--text-muted)";
  const tblHeadColor  = "var(--table-head-text)";
  const colBgLinha    = (idx, isDragOver, isDragging) =>
    isDragOver  ? "var(--bs-primary-bg-subtle, #cfe2ff)" :
    isDragging  ? "var(--surface-sunken)" :
    idx % 2 === 0 ? "var(--surface-card)" : "var(--table-stripe)";

  const getNomeColuna = (col) => col.accessor || col.id || "";

  const effectiveColumns = useMemo(() => {
    if (!habilitaVisaoColunas || !visaoColunas || visaoColunas.length === 0) return columns;
    const byNome = columns.reduce((acc, c) => {
      const nome = getNomeColuna(c);
      acc[nome] = c;
      return acc;
    }, {});
    const ordered = visaoColunas
      .filter((c) => c.visivel === "S")
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
      .map((c) => {
        const col = byNome[c.nome_coluna] || { accessor: c.nome_coluna, id: c.nome_coluna };
        const headerSalvo = normalizarLabelColuna(c.nome_coluna, c.label || c.nome_coluna);
        const usaHeaderDoComponente = headerSalvo === c.nome_coluna && col.Header;
        return { ...col, Header: usaHeaderDoComponente ? col.Header : (headerSalvo || col.Header || c.nome_coluna) };
      });
    return ordered.length > 0 ? ordered : columns;
  }, [habilitaVisaoColunas, columns, visaoColunas]);

  const columnsVisiveis = mostrarColunaId
    ? effectiveColumns
    : effectiveColumns.filter(
        (c) => !((c.accessor || c.id) === "id" && c.Header === "ID")
      );

  const hasDtVencimentoColumn = effectiveColumns.some((c) => c.accessor === "dt_vencimento");

  const buildServerParams = useCallback(() => ({
    pagina: currentPage,
    limite: itemsPerPage,
    ordenar: sortColumn || defaultSortColumn || "id",
    direcao: sortOrder === "asc" ? "ASC" : "DESC",
    filters,
    dateFilters,
    numericFilters,
    diasParaVencimento,
  }), [
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
    defaultSortColumn,
    filters,
    dateFilters,
    numericFilters,
    diasParaVencimento,
  ]);

  useEffect(() => {
    if (!serverSide || !onServerParamsChangeRef.current) return undefined;
    const timer = setTimeout(() => {
      const params = buildServerParams();
      const key = JSON.stringify(params);
      if (lastServerParamsRef.current === key) return;
      lastServerParamsRef.current = key;
      onServerParamsChangeRef.current(params);
    }, 250);
    return () => clearTimeout(timer);
  }, [serverSide, buildServerParams]);

  useEffect(() => {
    if (!habilitaVisaoColunas || !rota || !entidadeId || !userId || !token) return;
    const rotaNorm = (rota || "").toLowerCase();
    const rotaPath = (rota || "").trim();
    const url = `${BASE_URL}/api/${rotaPath}/ObterVisaoColunas/${entidadeId}/${userId}`;
    const config = {
      params: { rota: rotaNorm },
      headers: { Authorization: `Bearer ${token}` },
    };
    api
      .get(url, config)
      .then((r) => {
        const colunas = r.data?.colunas;
        if (Array.isArray(colunas) && colunas.length > 0) {
          const sorted = [...colunas].sort(sortColunasPorVisivelEOrdem);
          setVisaoColunas(sorted);
        }
      })
      .catch((err) => {
        console.error("[GridPadrao] GET ObterVisaoColunas - erro:", err.response?.status, err.response?.data, {
          url,
          params: config.params,
        });
      });
  }, [habilitaVisaoColunas, rota, entidadeId, userId, token]);

  const openColunasModal = () => {
    //console.log("[GridPadrao] ObterVisaoColunas - retorno ao abrir modal (visaoColunas):", JSON.stringify({ colunas: visaoColunas }));
    if (visaoColunas.length > 0) {
      setColunasModalList(buildColunasModalListFromColunas(visaoColunas));
    } else {
      setColunasModalList(
        columns.map((col, i) => ({
          nome_coluna: getNomeColuna(col),
          ordem: i + 1,
          visivel: "S",
          Header: col.Header || getNomeColuna(col),
        }))
      );
    }
    setShowColunasModal(true);
  };

  const saveVisaoColunas = (colunasToSave) => {
    if (!habilitaVisaoColunas || !rota || !entidadeId || !userId || !token) return Promise.reject();
    const rotaNorm = (rota || "").toLowerCase();
    const rotaPath = (rota || "").trim();
    return api.put(
      `${BASE_URL}/api/${rotaPath}/SalvarVisaoColunas/${entidadeId}/${userId}`,
      { rota: rotaNorm, colunas: colunasToSave },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  const handleSalvarColunas = () => {
    setSavingColunas(true);
    const payload = colunasModalList.map(({ nome_coluna, ordem, visivel }) => ({
      nome_coluna,
      ordem,
      visivel,
    }));
    saveVisaoColunas(payload)
      .then(() => fetchObterVisaoColunas())
      .then((r) => {
        const colunas = r?.data?.colunas;
        if (Array.isArray(colunas) && colunas.length > 0) {
          const sorted = [...colunas].sort(sortColunasPorVisivelEOrdem);
          setVisaoColunas(sorted);
        } else {
          setVisaoColunas(payload);
        }
        setShowColunasModal(false);
      })
      .catch((err) => {
        console.error("Erro ao salvar colunas:", err);
        toast.error(err.response?.data?.message || "Erro ao salvar colunas. Tente novamente.");
      })
      .finally(() => setSavingColunas(false));
  };

  const fetchObterVisaoColunas = () => {
    if (!habilitaVisaoColunas || !rota || !entidadeId || !userId || !token) return Promise.reject(new Error("Visão colunas desabilitada"));
    const rotaNorm = (rota || "").toLowerCase();
    const rotaPath = (rota || "").trim();
    const url = `${BASE_URL}/api/${rotaPath}/ObterVisaoColunas/${entidadeId}/${userId}`;
    return api.get(url, {
      params: { rota: rotaNorm },
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  const buildColunasModalListFromColunas = (colunas) => {
    const byNome = columns.reduce((acc, c) => {
      acc[getNomeColuna(c)] = c;
      return acc;
    }, {});
    const list = colunas.map((c) => ({
      id: c.id,
      nome_coluna: c.nome_coluna,
      label: normalizarLabelColuna(c.nome_coluna, c.label),
      ordem: c.ordem,
      visivel: c.visivel,
      origem: c.origem,
      Header: normalizarLabelColuna(
        c.nome_coluna,
        c.label || (byNome[c.nome_coluna] && byNome[c.nome_coluna].Header) || c.nome_coluna
      ),
    }));
    columns.forEach((col) => {
      const nome = getNomeColuna(col);
      if (!colunas.some((v) => v.nome_coluna === nome)) {
        list.push({
          nome_coluna: nome,
          label: col.Header || nome,
          ordem: list.length + 1,
          visivel: "S",
          origem: "P",
          Header: col.Header || nome,
        });
      }
    });
    return list.sort(sortColunasPorVisivelEOrdem);
  };

  const executarVisaoColunasPadrao = () => {
    const rotaNorm = (rota || "documentos").toLowerCase();
    return api.post(
      `${BASE_URL}/api/usuarios/ExecutarVisaoColunasPadrao/${entidadeId}/${userId}`,
      { rota: rotaNorm },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  const handleVoltarPadraoColunas = () => {
    setSavingColunas(true);
    executarVisaoColunasPadrao()
      .then(() => fetchObterVisaoColunas())
      .then((r) => {
        const colunas = r.data?.colunas;
        if (Array.isArray(colunas) && colunas.length > 0) {
          const sorted = [...colunas].sort(sortColunasPorVisivelEOrdem);
          setVisaoColunas(sorted);
          setColunasModalList(buildColunasModalListFromColunas(sorted));
        } else {
          setVisaoColunas([]);
          setColunasModalList(
            columns.map((col, i) => ({
              nome_coluna: getNomeColuna(col),
              label: col.Header || getNomeColuna(col),
              ordem: i + 1,
              visivel: "S",
              Header: col.Header || getNomeColuna(col),
            }))
          );
        }
      })
      .catch((err) => {
        console.error("Erro ao restaurar padrão:", err);
        toast.error(err.response?.data?.message || "Erro ao restaurar padrão. Tente novamente.");
      })
      .finally(() => setSavingColunas(false));
  };

  const onColDragStart = (e, idx) => {
    dragColNode.current = e.currentTarget;
    setDragColIdx(idx);
    e.dataTransfer.effectAllowed = "move";
    const ghost = document.createElement("div");
    ghost.style.position = "absolute";
    ghost.style.top = "-9999px";
    document.body.appendChild(ghost);
    e.dataTransfer.setDragImage(ghost, 0, 0);
    setTimeout(() => document.body.removeChild(ghost), 0);
  };

  const onColDragOver = (e, idx) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (idx !== overColIdx) setOverColIdx(idx);
  };

  const onColDrop = (e, idx) => {
    e.preventDefault();
    if (dragColIdx === null || dragColIdx === idx) { endColDrag(); return; }
    setColunasModalList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(dragColIdx, 1);
      next.splice(idx, 0, moved);
      next.forEach((c, i) => { c.ordem = i + 1; });
      return next;
    });
    endColDrag();
  };

  const endColDrag = () => { setDragColIdx(null); setOverColIdx(null); dragColNode.current = null; };

  const toggleVisivelColunaModal = (index) => {
    setColunasModalList((prev) => {
      const next = [...prev];
      next[index] = {
        ...next[index],
        visivel: next[index].visivel === "S" ? "N" : "S",
      };
      return next;
    });
  };

  const loadFiltrosPadrao = useCallback(() => {
    if (!rota || !userId || !token) return;
    api
      .get(`${BASE_URL}/api/usuarios/ObterFiltrosPadrao/${userId}`, {
        params: { id_entidade: entidadeId || undefined },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => {
        const fp = r.data?.filtros_padrao;
        const fj = fp && fp[rota];
        if (fj && (fj.filters || fj.dateFilters || fj.diasParaVencimento != null)) {
          setFilters((prev) => {
            const next = fj.filters || prev;
            return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
          });
          setDateFilters((prev) => {
            const next = fj.dateFilters || prev;
            return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
          });
          const dias =
            fj.diasParaVencimento != null && fj.diasParaVencimento !== ""
              ? String(fj.diasParaVencimento)
              : "";
          setDiasParaVencimento((prev) => (prev === dias ? prev : dias));
        }
      })
      .catch((err) => console.error("Erro ao carregar filtros padrão:", err));
  }, [rota, userId, entidadeId, token]);

  useEffect(() => {
    if (rota) loadFiltrosPadrao();
  }, [rota, loadFiltrosPadrao]);

  const handleCarregarFiltroPadrao = () => {
    if (!rota || !userId || !token) return;
    setLoadingCarregar(true);
    api
      .get(`${BASE_URL}/api/usuarios/ObterFiltrosPadrao/${userId}`, {
        params: { id_entidade: entidadeId || undefined },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((r) => {
        const fp = r.data?.filtros_padrao;
        const fj = fp && fp[rota];
        if (fj && (fj.filters || fj.dateFilters || fj.diasParaVencimento != null)) {
          setFilters(fj.filters || defaultF);
          setDateFilters(fj.dateFilters || defaultDF);
          setDiasParaVencimento(fj.diasParaVencimento != null && fj.diasParaVencimento !== "" ? String(fj.diasParaVencimento) : "");
        } else {
          setFilters(defaultF);
          setDateFilters(defaultDF);
          setDiasParaVencimento("");
        }
      })
      .catch((err) => {
        console.error("Erro ao carregar filtros padrão:", err);
      })
      .finally(() => setLoadingCarregar(false));
  };

  const handleSalvarFiltro = () => {
    if (!rota || !userId || !token) return;
    setSavingFilter(true);
    api
      .get(`${BASE_URL}/api/usuarios/ObterFiltrosPadrao/${userId}`, {
        params: { id_entidade: entidadeId || undefined },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((getRes) => {
        const fp = getRes.data?.filtros_padrao || {};
        const filtros_padrao = {
          ...fp,
          [rota]: { filters, dateFilters, diasParaVencimento: diasParaVencimento || null },
        };
        return api.put(
          `${BASE_URL}/api/usuarios/DefinirFiltrosPadrao/${userId}`,
          { filtros_padrao, id_entidade: entidadeId || null },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      })
      .then(() => toast.success("Filtro salvo com sucesso!"))
      .catch((err) => {
        console.error("Erro ao salvar filtro:", err);
        toast.error(err.response?.data?.message || "Erro ao salvar filtro. Tente novamente.");
      })
      .finally(() => setSavingFilter(false));
  };

  // Manipula a ordenação
  const handleSort = (column) => {
    const newSortOrder =
      sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newSortOrder);
    setCurrentPage(1);
  };

  // Manipula os filtros de texto
  const handleFilter = (value, column) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      [column]: String(value || "").toLowerCase(),
    });
  };

  // Compara texto usando sintaxe parecida com SQL LIKE (%CIMENTO, %CIMENTO%, CIMENTO%, etc.), case-insensitive
  const matchesTextFilter = (rowVal, filterVal) => {
    const text = String(rowVal || "").toLowerCase();
    const pattern = String(filterVal || "").toLowerCase();
    if (!pattern) return true;

    // Sem % => mantém comportamento atual (contains)
    if (!pattern.includes("%")) {
      return text.includes(pattern);
    }

    // Converte padrão com % para regex
    const escaped = pattern.replace(/[-/\\^$+?.()|[\]{}]/g, "\\$&");
    const regexStr = "^" + escaped.replace(/%/g, ".*") + "$";
    const regex = new RegExp(regexStr);
    return regex.test(text);
  };

  // Extrai valores únicos de uma coluna para o modal de filtro (estável por referência quando data não muda)
  const getUniqueValuesForColumn = useCallback((column) => {
    const accessor = column.accessor;
    const getValue = column.getFilterValue || ((row) => row[accessor]);
    const values = new Set();
    data.forEach((row) => {
      let val = getValue(row);
      if (val !== undefined && val !== null && val !== "") {
        const str = String(val).trim();
        if (str) values.add(str);
      }
    });
    return Array.from(values).sort((a, b) => String(a).localeCompare(String(b)));
  }, [data]);

  const openFilterModal = (column) => {
    setFilterModalColumn(column);
    const current = filters[column.accessor];
    const preSel = Array.isArray(current)
      ? current.reduce((acc, v) => ({ ...acc, [v]: true }), {})
      : {};
    setFilterModalSelections(preSel);
  };

  const handleFilterModalToggle = (value) => {
    const key = String(value).toLowerCase();
    setFilterModalSelections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleFilterModalApply = () => {
    if (!filterModalColumn) return;
    const selected = Object.entries(filterModalSelections)
      .filter(([, checked]) => checked)
      .map(([val]) => val);
    setFilters((prev) => ({
      ...prev,
      [filterModalColumn.accessor]: selected.length > 0 ? selected : "",
    }));
    setFilterModalColumn(null);
  };

  const handleFilterModalSelectAll = (values) => {
    const next = {};
    values.forEach((v) => {
      next[String(v).toLowerCase()] = true;
    });
    setFilterModalSelections(next);
  };

  const handleFilterModalClearAll = () => {
    setFilterModalSelections({});
  };

  const handleFilterModalClose = () => {
    setFilterModalColumn(null);
  };

  // Filtra e ordena os dados (no modo serverSide, filtros de situação/ordem/página vão ao backend)
  const diasNum = diasParaVencimento !== "" && diasParaVencimento != null ? parseInt(String(diasParaVencimento).trim(), 10) : null;
  const clientProcessedData = data
    .filter((row) => {
      if (serverSide) {
        const serverSideFilters = ["situacao"];
        const normalFiltersPass = Object.keys(filters).every((columnAccessor) => {
          if (serverSideFilters.includes(columnAccessor)) return true;
          const f = filters[columnAccessor];
          if (!f) return true;
          const colConfig = columns.find((c) => c.accessor === columnAccessor);
          const rowVal = getFilterableValue(row, columnAccessor, colConfig);
          if (Array.isArray(f)) {
            return f.length > 0 && f.some((v) => rowVal === v);
          }
          return matchesTextFilter(rowVal, f);
        });
        const numericFiltersPass = Object.keys(numericFilters).every((column) => {
          if (!numericFilters[column]) return true;
          return applyNumericFilter(row[column], numericFilters[column]);
        });
        const dateFiltersPass = Object.keys(dateFilters).every((column) => {
          return applyDateFilter(row[column], dateFilters[column]);
        });
        const diasPass =
          !hasDtVencimentoColumn || diasNum == null || Number.isNaN(diasNum)
            ? true
            : (() => {
                const dias = calcDiasParaVcto(row.dt_vencimento);
                return dias !== null && dias <= diasNum;
              })();
        return normalFiltersPass && numericFiltersPass && dateFiltersPass && diasPass;
      }

      // Aplica os filtros normais (não datas)
      const normalFiltersPass = Object.keys(filters).every((columnAccessor) => {
        const f = filters[columnAccessor];
        if (!f) return true;
        const colConfig = columns.find((c) => c.accessor === columnAccessor);
        const rowVal = getFilterableValue(row, columnAccessor, colConfig);
        if (Array.isArray(f)) {
          return f.length > 0 && f.some((v) => rowVal === v);
        }
        if (columnAccessor === "situacao") {
          return String(rowVal).toLowerCase() === String(f).toLowerCase();
        }
        return matchesTextFilter(rowVal, f);
      });

      // Aplica os filtros numéricos (ex: "Nº Dias para Vencimento")
      const numericFiltersPass = Object.keys(numericFilters).every((column) => {
        if (!numericFilters[column]) return true;
        return applyNumericFilter(row[column], numericFilters[column]);
      });

      // Aplica os filtros de datas
      const dateFiltersPass = Object.keys(dateFilters).every((column) => {
        return applyDateFilter(row[column], dateFilters[column]);
      });

      // Filtro "vencer em até N dias" (quando existe coluna dt_vencimento)
      const diasPass =
        !hasDtVencimentoColumn || diasNum == null || Number.isNaN(diasNum)
          ? true
          : (() => {
              const dias = calcDiasParaVcto(row.dt_vencimento);
              return dias !== null && dias <= diasNum;
            })();

      return normalFiltersPass && numericFiltersPass && dateFiltersPass && diasPass;
    })
    .sort((a, b) => {
      if (serverSide) return 0;
      if (!sortColumn) return 0;
      const col =
        effectiveColumns.find((c) => (c.accessor || c.id) === sortColumn) ||
        columns.find((c) => c.accessor === sortColumn);
      const isDateColumn = col?.type === "date" || /^dt_|_data$|data_/.test(sortColumn);

      const getVal = (row) => {
        if (col?.getSortValue) return col.getSortValue(row);
        if (col?.getFilterValue) return col.getFilterValue(row);
        return row[sortColumn];
      };
      const aVal = getVal(a);
      const bVal = getVal(b);

      if (isDateColumn) {
        const aDate = aVal ? new Date(aVal).getTime() : Infinity;
        const bDate = bVal ? new Date(bVal).getTime() : Infinity;
        return sortOrder === "asc" ? aDate - bDate : bDate - aDate;
      }

      const aStr = String(aVal ?? "").toLowerCase();
      const bStr = String(bVal ?? "").toLowerCase();
      if (sortOrder === "asc") {
        return aStr > bStr ? 1 : aStr < bStr ? -1 : 0;
      } else {
        return aStr < bStr ? 1 : aStr > bStr ? -1 : 0;
      }
    });

  const filteredData = clientProcessedData;
  const totalFilteredRecords = serverSide ? totalItems : filteredData.length;
  const totalPages = serverSide
    ? (totalFilteredRecords > 0 ? Math.ceil(totalFilteredRecords / itemsPerPage) : 0)
    : Math.ceil(filteredData.length / itemsPerPage);
  const startRecord =
    totalFilteredRecords === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endRecord = serverSide
    ? Math.min(currentPage * itemsPerPage, totalFilteredRecords)
    : Math.min(currentPage * itemsPerPage, totalFilteredRecords);

  // Manipula a mudança de página
  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  // Manipula a mudança de quantidade de itens por página
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Pega os dados paginados
  const paginatedData = serverSide
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const showLoadingState = loading && (!serverSide || paginatedData.length === 0);

  // Item #36 (LGPD): null/ausente (config ainda não carregada) é tratado como
  // "oculta" — falha segura, nunca vaza dado sensível por uma corrida de fetch.
  const lgpdAtivo = globalData?.lgpdOcultarDados !== false;
  const temMascaraLgpd = lgpdAtivo && Object.keys(exportMaskColumns).length > 0;

  // Exporta para Excel
  const exportToExcel = () => {
    let dataParaExportar = exportExcludeColumns.length
      ? filteredData.map((row) => {
          const copia = { ...row };
          exportExcludeColumns.forEach((col) => delete copia[col]);
          return copia;
        })
      : filteredData;

    if (temMascaraLgpd) {
      dataParaExportar = dataParaExportar.map((row) => {
        const copia = { ...row };
        Object.entries(exportMaskColumns).forEach(([coluna, tipo]) => {
          if (coluna in copia) copia[coluna] = mascararValor(copia[coluna], tipo);
        });
        return copia;
      });
    }

    const worksheet = utils.json_to_sheet(dataParaExportar);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Dados");
    writeFile(workbook, "dados.xlsx");
  };

  // Manipula o clique para testar o envio de email
  const handleTestClick = (row) => {
    setSelectedRow(row);
    setShowTestModal(true);
  };

  // Testa o envio de email — o modal permanece aberto e exibe o resultado internamente
  const handleTestEmail = async (email) => {
    if (onTest) {
      await onTest(selectedRow, email);
    }
  };

  // Manipula o filtro para datas com operadores
  const handleDateFilter = (column, operator, value) => {
    setDateFilters((prevFilters) => ({
      ...prevFilters,
      [column]: {
        operator: operator || "=",
        value: value ?? "",
      },
    }));
  };

  // Verifica se há filtros ativos
  const hasActiveFilters = () => {
    return (
      Object.values(filters).some((value) => value) ||
      Object.values(numericFilters).some((value) => value !== "") ||
      Object.values(dateFilters).some((filter) => filter && filter.value) ||
      (diasParaVencimento !== "" && diasParaVencimento != null)
    );
  };

  // Contagem de filtros ativos
  const getActiveFiltersCount = () => {
    return (
      Object.keys(filters).filter((k) => filters[k]).length +
      Object.keys(numericFilters).filter((k) => numericFilters[k] !== "")
        .length +
      Object.keys(dateFilters).filter(
        (k) => dateFilters[k] && dateFilters[k].value
      ).length +
      (diasParaVencimento !== "" && diasParaVencimento != null ? 1 : 0)
    );
  };

  // Limpa todos os filtros
  const clearAllFilters = () => {
    setFilters({});
    setNumericFilters({});
    setDateFilters({});
    setDiasParaVencimento("");
  };

  return (
    <div className="grid-padrao-container">
      <Card className="shadow-sm mb-4 border-0" style={{ background: colBg, color: colTexto }}>
        <Card.Body>
          {/* Cabeçalho com controles */}
          <div className="grid-toolbar d-flex justify-content-between align-items-center mb-3">
            <div className="grid-toolbar-left d-flex align-items-center">
              <div className="me-3 d-flex align-items-center">
                <Form.Select
                  size="sm"
                  className="me-2"
                  style={{ width: "70px", background: colBg, color: colTexto, borderColor: colBorda }}
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  {[
                    ...new Set([numeroLinhasConfig, ...OPCOES_PADRAO].sort((a, b) => a - b)),
                  ].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </Form.Select>
                <span className="text-muted small">registros</span>
              </div>

              <Button
                variant={showFilters ? "primary" : "outline-secondary"}
                size="sm"
                className="d-flex align-items-center"
                onClick={() => setShowFilters(!showFilters)}
              >
                <FaFilter className="me-1" />
                <span>Filtros</span>
                {hasActiveFilters() && (
                  <Badge bg="danger" pill className="ms-1">
                    {getActiveFiltersCount()}
                  </Badge>
                )}
              </Button>

              {hasActiveFilters() && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="ms-2 d-flex align-items-center"
                  onClick={clearAllFilters}
                >
                  <FaTimes className="me-1" />
                  <span>Limpar</span>
                </Button>
              )}
            </div>

            <div className="grid-toolbar-actions d-flex">
              <Button
                variant="outline-success"
                size="sm"
                className="me-2 d-flex align-items-center"
                onClick={exportToExcel}
              >
                <FaFileExcel className="me-1" />
                <span>Exportar</span>
              </Button>

              {rota && habilitaVisaoColunas && (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="me-2 d-flex align-items-center"
                  onClick={openColunasModal}
                  title="Configurar colunas visíveis"
                >
                  <FaColumns className="me-1" />
                  <span>Colunas</span>
                </Button>
              )}

              {acoesBotoes && (
                <div className="grid-extra-actions d-flex align-items-center me-2">
                  {acoesBotoes}
                </div>
              )}

              {onAdd && (
                <Adicionar
                  onClick={onAdd}
                  disabled={addDisabled}
                  title={addDisabled ? (addDisabledTitle || "Ação indisponível") : undefined}
                  data-tour={addDataTour}
                />
              )}
            </div>
          </div>

          {/* Painel de Filtros */}
          {showFilters && (
            <Card className="mb-3 border" style={{ background: colBgHead, borderColor: colBorda }}>
              <Card.Body className="py-2">
                <Row className="g-2">
                  {columnsVisiveis.map((column) => {
                    if (column.hideFilter) return null;
                    if (column.type === "date") {
                      return (
                        <Col md={3} key={column.accessor}>
                          <Form.Group>
                            <Form.Label className="small fw-bold mb-1" style={{ color: colTextoMuted }}>
                              {column.Header}
                            </Form.Label>
                            <div className="d-flex gap-1">
                              <Form.Select
                                size="sm"
                                className="flex-grow-0"
                                style={{ width: "65px", background: colBg, color: colTexto, borderColor: colBorda }}
                                value={dateFilters[column.accessor]?.operator ?? "="}
                                onChange={(e) => {
                                  const newOp = e.target.value || "=";
                                  handleDateFilter(
                                    column.accessor,
                                    newOp,
                                    dateFilters[column.accessor]?.value ?? ""
                                  );
                                }}
                              >
                                <option value="=">=</option>
                                <option value=">">&gt;</option>
                                <option value="<">&lt;</option>
                                <option value=">=">&gt;=</option>
                                <option value="<=">&lt;=</option>
                              </Form.Select>
                              <Form.Control
                                type="date"
                                size="sm"
                                className="flex-grow-1"
                                style={{ background: colBg, color: colTexto, borderColor: colBorda, colorScheme: darkMode ? "dark" : "light" }}
                                onChange={(e) =>
                                  handleDateFilter(
                                    column.accessor,
                                    dateFilters[column.accessor]?.operator ?? "=",
                                    e.target.value
                                  )
                                }
                                value={dateFilters[column.accessor]?.value ?? ""}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      );
                    } else if (column.Header === "Situação") {
                      const opcoes = situacaoFilterOptions && situacaoFilterOptions.length > 0
                        ? situacaoFilterOptions
                        : [
                            { value: "a", label: "Ativo" },
                            { value: "i", label: "Inativo" },
                          ];
                      return (
                        <React.Fragment key={column.accessor}>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label className="small fw-bold mb-1">
                                {column.Header}
                              </Form.Label>
                              <Form.Select
                                size="sm"
                                style={{ background: colBg, color: colTexto, borderColor: colBorda }}
                                onChange={(e) =>
                                  handleFilter(e.target.value, column.accessor)
                                }
                                value={filters[column.accessor] || ""}
                              >
                                <option value="">Todos</option>
                                {opcoes.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          {hasDtVencimentoColumn && (
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label className="small fw-bold mb-1">
                                  Nº de dias (vencer em até)
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  size="sm"
                                  min={0}
                                  placeholder="Em branco = todos"
                                  style={{ background: colBg, color: colTexto, borderColor: colBorda }}
                                  value={diasParaVencimento}
                                  onChange={(e) => setDiasParaVencimento(e.target.value)}
                                />
                                <Form.Text className="text-muted small">
                                  Ex.: 30 = vence em até 30 dias
                                </Form.Text>
                              </Form.Group>
                            </Col>
                          )}
                        </React.Fragment>
                      );
                    } else if (column.accessor === "dias_vcto") {
                      return null; // Tratado diretamente na tabela
                    } else {
                      const filterVal = filters[column.accessor];
                      const isArrayFilter = Array.isArray(filterVal) && filterVal.length > 0;
                      return (
                        <Col md={3} key={column.accessor}>
                          <Form.Group>
                            <Form.Label className="small fw-bold mb-1">
                              {column.Header}
                              {isArrayFilter && (
                                <Badge bg="info" className="ms-1" pill>
                                  {filterVal.length}
                                </Badge>
                              )}
                            </Form.Label>
                            <InputGroup size="sm">
                              <InputGroup.Text
                                style={{ cursor: "pointer", background: colBgHead, borderColor: colBorda, color: colTextoMuted }}
                                onClick={() => openFilterModal(column)}
                                title="Abrir lista de valores para filtrar"
                                role="button"
                              >
                                <FaSearch size={12} />
                              </InputGroup.Text>
                              <Form.Control
                                type="text"
                                placeholder={isArrayFilter ? `${filterVal.length} selecionado(s)` : "Pesquisar..."}
                                style={{ background: colBg, color: colTexto, borderColor: colBorda }}
                                onChange={(e) =>
                                  handleFilter(e.target.value, column.accessor)
                                }
                                value={Array.isArray(filterVal) ? "" : (filterVal || "")}
                              />
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      );
                    }
                  })}
                </Row>
                {rota && (
                  <div className="grid-filter-footer mt-2 pt-2 border-top" style={{ borderTopColor: colBorda }}>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleSalvarFiltro}
                      disabled={savingFilter}
                    >
                      <FaSave className="me-1" />
                      Salvar Filtro
                    </Button>
                    <span className="text-muted small ms-2">
                      Salva os filtros atuais como padrão para esta tela
                    </span>
                    <div className="mt-2">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleCarregarFiltroPadrao}
                        disabled={loadingCarregar}
                      >
                        <FaDownload className="me-1" />
                        Carregar Filtro Padrão
                      </Button>
                      <span className="text-muted small ms-2">
                        Aplica o filtro padrão salvo
                      </span>
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          {/* Tabela de dados */}
          <div className="grid-table-scroll table-responsive">
            <Table hover className="align-middle mb-0">
              <thead>
                <tr style={{ background: colBgHead }}>
                  {columnsVisiveis.map((column) => (
                    <th
                      key={column.accessor}
                      style={{
                        ...(column.accessor === "dt_vencimento" ? { width: "150px" } : {}),
                        fontWeight: 700,
                        fontSize: "0.72rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        color: tblHeadColor,
                        padding: "10px 12px",
                        borderColor: colBorda,
                        whiteSpace: "nowrap",
                        borderTop: "none",
                      }}
                    >
                      <div
                        className="d-flex align-items-center"
                        onClick={() => handleSort(column.accessor)}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="me-1">{column.Header}</span>
                        <span className="ms-auto">
                          {sortColumn === column.accessor ? (
                            sortOrder === "asc" ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )
                          ) : (
                            <FaSort color="var(--border-default)" />
                          )}
                        </span>
                      </div>
                    </th>
                  ))}
                  {temColunaAcoes && (
                    <th style={{ width: "150px", fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.4px", color: tblHeadColor, padding: "10px 12px", borderColor: colBorda, borderTop: "none" }}>Ações</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {showLoadingState ? (
                  <tr>
                    <td
                      colSpan={columnsVisiveis.length + (temColunaAcoes ? 1 : 0)}
                      className="text-center py-4"
                      style={{ color: colTextoMuted, borderColor: colBorda, background: colBg }}
                    >
                      Carregando...
                    </td>
                  </tr>
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columnsVisiveis.length + (temColunaAcoes ? 1 : 0)}
                      className="text-center py-4"
                      style={{ color: colTextoMuted, borderColor: colBorda, background: colBg }}
                    >
                      Nenhum registro encontrado
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((row, index) => {
                    const isRowEditable =
                      onEdit &&
                      !(row.permiteEdicao === "N" && row.id_entidade == null);
                    return (
                    <tr
                      key={index}
                      data-tour={index === 0 ? firstRowDataTour : undefined}
                      style={{ background: colBg, ...(isRowEditable ? { cursor: "pointer" } : {}) }}
                      onClick={
                        isRowEditable
                          ? (e) => {
                              if (
                                e.detail === 2 &&
                                !e.target.closest("button") &&
                                !e.target.closest('[role="button"]')
                              ) {
                                onEdit(row, row.permiteEdicao);
                              }
                            }
                          : undefined
                      }
                    >
                      {columnsVisiveis.map((column) => (
                        <td
                          key={column.accessor}
                          style={{
                            ...(column.accessor === "dt_vencimento" ? { width: "150px" } : {}),
                            color: colTexto,
                            borderColor: colBorda,
                            padding: "9px 12px",
                            fontSize: "0.875rem",
                            verticalAlign: "middle",
                          }}
                        >
                          {column.Cell ? (
                            column.Cell({ row })
                          ) : column.accessor === "situacao" ? (
                            (() => {
                              const s = row.situacao;
                              const isDocGrid = situacaoFilterOptions && situacaoFilterOptions.length > 0;
                              const label = isDocGrid ? (s === "V" ? "Vigente" : s === "A" ? "Arquivado" : s || "—") : (s === "A" ? "Ativo" : "Inativo");
                              const bg = isDocGrid ? (s === "V" ? "success" : "secondary") : (s === "A" ? "success" : "secondary");
                              return (
                                <Badge bg={bg} pill>
                                  {label}
                                </Badge>
                              );
                            })()
                          ) : (row[column.accessor] !== undefined && row[column.accessor] !== null && row[column.accessor] !== "") ? (
                            row[column.accessor]
                          ) : (
                            <span style={{ color: colTextoMuted }}>—</span>
                          )}
                        </td>
                      ))}
                      {temColunaAcoes && (
                      <td style={{ borderColor: colBorda, padding: "9px 12px", verticalAlign: "middle" }} onClick={(e) => e.stopPropagation()}>
                        <div className="grid-row-actions d-flex gap-1">
                          {onAcao && (
                            <Button
                              variant={acaoVariant}
                              size="sm"
                              className="p-1"
                              data-tour={index === 0 ? acaoDataTour : undefined}
                              onClick={() => onAcao(row)}
                              title={acaoTitulo}
                            >
                              {AcaoIcone ? <AcaoIcone size={14} /> : <span style={{ fontSize: 12 }}>★</span>}
                            </Button>
                          )}
                          {onAcao2 && (
                            <Button
                              variant={acao2Variant}
                              size="sm"
                              className="p-1"
                              onClick={() => onAcao2(row)}
                              title={acao2Titulo}
                            >
                              {Acao2Icone ? (
                                <Acao2Icone size={14} />
                              ) : (
                                <span style={{ fontSize: 12, fontWeight: 600 }}>$</span>
                              )}
                            </Button>
                          )}
                          {onConfigCampos && (
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="p-1"
                              data-tour={index === 0 ? configCamposDataTour : undefined}
                              onClick={() => onConfigCampos(row)}
                              title="Configurações de Campos"
                            >
                              <FaCog size={14} />
                            </Button>
                          )}
                          {onPrintPdf && (
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              className="p-1"
                              onClick={() => onPrintPdf(row)}
                              title="Pré-visualizar PDF"
                            >
                              <FaFilePdf size={14} />
                            </Button>
                          )}
                          {onInactivate && (
                            row.permiteEdicao === "N" && row.id_entidade == null ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-excluir-disabled-${index}`}>
                                    Exclusão não permitida para itens Padrão do Sistema
                                  </Tooltip>
                                }
                              >
                                <span className="d-inline-block" style={{ cursor: "not-allowed" }}>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="p-1"
                                    disabled
                                    style={{ pointerEvents: "none" }}
                                    title="Excluir"
                                  >
                                    <FaTrash size={14} />
                                  </Button>
                                </span>
                              </OverlayTrigger>
                            ) : disableInactivateWhen?.(row) ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-excluir-disabled-respostas-${index}`}>
                                    {disableInactivateTooltip || "Exclusão não permitida"}
                                  </Tooltip>
                                }
                              >
                                <span className="d-inline-block" style={{ cursor: "not-allowed" }}>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="p-1"
                                    disabled
                                    style={{ pointerEvents: "none" }}
                                    title="Excluir"
                                  >
                                    <FaTrash size={14} />
                                  </Button>
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                className="p-1"
                                onClick={() => onInactivate(row)}
                                title="Excluir"
                              >
                                <FaTrash size={14} />
                              </Button>
                            )
                          )}

                          {onTest && (row.situacao === "A" || row.situacao === "V") && (
                            <Button
                              variant="outline-success"
                              size="sm"
                              className="p-1"
                              onClick={() => handleTestClick(row)}
                              title="Teste"
                            >
                              <FaPaperPlane size={14} />
                            </Button>
                          )}
                        </div>
                      </td>
                      )}
                    </tr>
                  );
                  })
                )}
              </tbody>
            </Table>
          </div>

          {/* Rodapé com paginação */}
          <div className="grid-footer d-flex justify-content-between align-items-center mt-3">
            <div className="grid-footer-summary">
              {totalFilteredRecords > 0 && (
                <span style={{ fontSize: "0.82rem", color: colTextoMuted }}>
                  Mostrando {startRecord} a {endRecord} de {totalFilteredRecords} registros
                </span>
              )}
            </div>

            {totalPages > 1 && (
              <Pagination size="sm" className="grid-pagination mb-0">
                <Pagination.First
                  onClick={() => handleChangePage(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => handleChangePage(currentPage - 1)}
                  disabled={currentPage === 1}
                />

                {[...Array(totalPages)].map((_, index) => {
                  const pageNum = index + 1;

                  // Mostrar sempre a primeira, a última e páginas próximas à atual
                  if (
                    pageNum === 1 ||
                    pageNum === totalPages ||
                    (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                  ) {
                    return (
                      <Pagination.Item
                        key={pageNum}
                        active={pageNum === currentPage}
                        onClick={() => handleChangePage(pageNum)}
                      >
                        {pageNum}
                      </Pagination.Item>
                    );
                  }

                  // Adicionar elipses para indicar páginas omitidas
                  if (pageNum === 2 && currentPage > 3) {
                    return (
                      <Pagination.Ellipsis key="ellipsis-start" disabled />
                    );
                  }

                  if (
                    pageNum === totalPages - 1 &&
                    currentPage < totalPages - 2
                  ) {
                    return <Pagination.Ellipsis key="ellipsis-end" disabled />;
                  }

                  return null;
                })}

                <Pagination.Next
                  onClick={() => handleChangePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
                <Pagination.Last
                  onClick={() => handleChangePage(totalPages)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            )}
          </div>
        </Card.Body>
      </Card>

      {/* Modal Colunas visíveis */}
      <Modal
        show={showColunasModal}
        onHide={() => setShowColunasModal(false)}
        backdrop="static"
        size="md"
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton style={{ background: colBgHead, borderColor: colBorda, paddingBottom: 12 }}>
          <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: colTexto }}>
            Colunas visíveis
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className={`gp-modal-body${darkMode ? " dark" : ""}`} style={{ padding: 0, maxHeight: "65vh", overflowY: "auto", background: colBg }}>
          {colunasModalList.length === 0 ? (
            <div className="text-center py-5" style={{ fontSize: "0.85rem", color: colTextoMuted }}>
              Nenhuma coluna disponível.
            </div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.82rem" }}>
              <thead>
                <tr style={{ background: colBgHead, borderBottom: `2px solid ${colBorda}`, position: "sticky", top: 0, zIndex: 1 }}>
                  <th style={{ width: 32, padding: "8px 6px" }} />
                  <th style={{ padding: "8px 12px", fontWeight: 600, color: colTexto }}>Coluna</th>
                  <th style={{ padding: "8px 12px", fontWeight: 600, color: colTexto }}>Origem</th>
                  <th style={{ padding: "8px 12px", fontWeight: 600, color: colTexto, textAlign: "center" }}>Visível</th>
                </tr>
              </thead>
              <tbody>
                {colunasModalList.map((item, idx) => {
                  const badge = BADGE_COLUNAS[item.origem] || {};
                  const isDragOver = idx === overColIdx;
                  const isDragging = idx === dragColIdx;
                  return (
                    <tr
                      key={item.nome_coluna}
                      draggable
                      onDragStart={(e) => onColDragStart(e, idx)}
                      onDragOver={(e) => onColDragOver(e, idx)}
                      onDrop={(e) => onColDrop(e, idx)}
                      onDragEnd={endColDrag}
                      style={{
                        background: colBgLinha(idx, isDragOver, isDragging),
                        transition: "background 0.1s",
                        borderBottom: `1px solid ${colBorda}`,
                        opacity: isDragging ? 0.5 : 1,
                      }}
                    >
                      <td style={{ padding: "6px 8px", cursor: "grab", color: colTextoMuted, textAlign: "center", userSelect: "none" }}>
                        <FaGripVertical />
                      </td>
                      <td style={{ padding: "6px 12px", color: colTexto, fontWeight: 500 }}>
                        {item.label || item.Header}
                      </td>
                      <td style={{ padding: "6px 12px" }}>
                        {badge.label && (
                          <span style={{
                            display: "inline-block", fontSize: "0.72rem", fontWeight: 600,
                            padding: "2px 7px", borderRadius: 20,
                            background: badge.bg, color: badge.color,
                          }}>
                            {badge.label}
                          </span>
                        )}
                      </td>
                      <td style={{ padding: "6px 12px", textAlign: "center" }}>
                        <Form.Check
                          type="switch"
                          id={`col-vis-${item.nome_coluna}`}
                          checked={item.visivel === "S"}
                          onChange={() => toggleVisivelColunaModal(idx)}
                          onMouseDown={(e) => e.stopPropagation()}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Modal.Body>

        <Modal.Footer className="modal-footer-padrao" style={{ background: colBgHead, borderColor: colBorda }}>
          <div className="modal-footer-acoes-esquerda">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={handleVoltarPadraoColunas}
              disabled={savingColunas}
            >
              Restaurar Padrão
            </Button>
            {colunasModalList.length > 0 && (
              <span style={{ fontSize: "0.78rem", color: colTextoMuted, marginLeft: 8 }}>
                {colunasModalList.length} coluna{colunasModalList.length !== 1 ? "s" : ""} · arraste para reordenar
              </span>
            )}
          </div>
          <div className="modal-footer-acoes-direita">
            <Button
              variant="light"
              className="modal-footer-btn-cancelar"
              onClick={() => setShowColunasModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="success"
              className="modal-footer-btn-salvar"
              onClick={handleSalvarColunas}
              disabled={savingColunas}
            >
              {savingColunas ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal para teste de e-mail */}
      <TestEmailModal
        show={showTestModal}
        handleClose={() => setShowTestModal(false)}
        onTestEmail={handleTestEmail}
        configId={selectedRow?.id}
      />

      {/* Modal de lista de valores para filtro */}
      <Modal
        show={!!filterModalColumn}
        onHide={handleFilterModalClose}
        size="lg"
        scrollable
      >
        <Modal.Header closeButton style={{ background: colBgHead, borderColor: colBorda }}>
          <Modal.Title style={{ fontSize: "0.95rem", fontWeight: 600, color: colTexto }}>
            Filtrar por {filterModalColumn?.Header || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ background: colBg }}>
          {filterModalColumn && (
            <>
              <div className="p-2 d-flex gap-1" style={{ borderBottom: `1px solid ${colBorda}` }}>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() =>
                    handleFilterModalSelectAll(
                      getUniqueValuesForColumn(filterModalColumn)
                    )
                  }
                >
                  Todos
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleFilterModalClearAll}
                >
                  Limpar
                </Button>
              </div>
              <ListGroup variant="flush">
                {getUniqueValuesForColumn(filterModalColumn).map((val) => {
                  const key = String(val).toLowerCase();
                  const checked = !!filterModalSelections[key];
                  return (
                    <ListGroup.Item
                      key={key}
                      action
                      active={checked}
                      onClick={() => handleFilterModalToggle(val)}
                      style={{
                        cursor: "pointer",
                        background: checked ? undefined : colBg,
                        color: checked ? undefined : colTexto,
                        borderColor: colBorda,
                      }}
                    >
                      {val || <em style={{ color: colTextoMuted }}>(vazio)</em>}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao" style={{ background: colBgHead, borderColor: colBorda }}>
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Button variant="light" className="modal-footer-btn-cancelar" onClick={handleFilterModalClose}>
              Cancelar
            </Button>
            <Button variant="success" className="modal-footer-btn-salvar" onClick={handleFilterModalApply}>
              Aplicar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default GridPadrao;
